import { Outlet } from 'react-router-dom';

import { Tabs, Typography } from 'enable-ui';
import { institutionDetailSelector, useStationStore } from 'stores/station';

import { RoleKey } from 'modules/auth/core/enum';
import { CustomTabs } from 'modules/classes/styles/tab';

import { ReactComponent as BackIcon } from 'assets/icons/back.svg';

import { checkRole } from 'helpers';

import { COLOR } from 'constants/color';
import { PATH } from 'constants/path';

import { useInstitutionInfoLayoutController } from '../core/controllers/layout';

export const InstitutionInfoLayout = () => {
  const institutionDetail = useStationStore(institutionDetailSelector);

  const { institutionName, isInstitutionDetail, institutionId, onTabClick, goBack } =
    useInstitutionInfoLayoutController();

  const isBiologicAdmin = checkRole([RoleKey.BIOLOGIC_ADMIN]);

  const tabs = [
    {
      children: <></>,
      key: isInstitutionDetail
        ? `${PATH.INSTITUTIONS}/${PATH.INSTITUTION_DETAIL.replace(':institutionId', institutionId ?? '')}/${PATH.INSTITUTION_GENERAL}`
        : `${PATH.INSTITUTION_INFO}/${PATH.INSTITUTION_GENERAL}`,
      label: 'General',
    },
    {
      children: <></>,
      key: isInstitutionDetail
        ? `${PATH.INSTITUTIONS}/${PATH.INSTITUTION_DETAIL.replace(':institutionId', institutionId ?? '')}/${PATH.INSTITUTION_STATIONS}`
        : `${PATH.INSTITUTION_INFO}/${PATH.INSTITUTION_STATIONS}`,
      label: 'Centers',
    },
  ];

  if (isBiologicAdmin) {
    tabs.push(
      {
        children: <></>,
        key: `${PATH.INSTITUTIONS}/${PATH.INSTITUTION_DETAIL.replace(':institutionId', institutionId ?? '')}/${PATH.EXERCISES}`,
        label: 'Exercises',
      },
      {
        children: <></>,
        key: `${PATH.INSTITUTIONS}/${PATH.INSTITUTION_DETAIL.replace(':institutionId', institutionId ?? '')}/${PATH.LESSONS}`,
        label: 'Lessons',
      },
      {
        children: <></>,
        key: `${PATH.INSTITUTIONS}/${PATH.INSTITUTION_DETAIL.replace(':institutionId', institutionId ?? '')}/${PATH.FUNCTIONAL_TESTS}`,
        label: 'Functional tests',
      },
      {
        children: <></>,
        key: `${PATH.INSTITUTIONS}/${PATH.INSTITUTION_DETAIL.replace(':institutionId', institutionId ?? '')}/${PATH.ASSESSMENTS}`,
        label: 'Assessments',
      },
      {
        children: <></>,
        key: `${PATH.INSTITUTIONS}/${PATH.INSTITUTION_DETAIL.replace(':institutionId', institutionId ?? '')}/${PATH.COURSES}`,
        label: 'Courses',
      },
      {
        children: <></>,
        key: `${PATH.INSTITUTIONS}/${PATH.INSTITUTION_DETAIL.replace(':institutionId', institutionId ?? '')}/${PATH.INSTITUTION_ANALYTICS}`,
        label: 'Analytics',
      },
    );
  }

  return (
    <div className="full-width">
      <div style={{ display: 'flex', alignItems: 'center', marginBottom: 16 }}>
        {isBiologicAdmin && (
          <BackIcon style={{ cursor: 'pointer', marginRight: 12 }} onClick={goBack} />
        )}
        <Typography
          style={{ fontSize: 26, lineHeight: '36px' }}
          weight={500}
          color={COLOR.surfaceNeutralBold['neutral-11']}
        >
          {isInstitutionDetail ? institutionDetail?.name : institutionName}
        </Typography>
      </div>

      <CustomTabs>
        <Tabs
          variant="text"
          items={tabs}
          activeKey={location.pathname}
          onTabClick={onTabClick}
          tabItemStyle={{
            height: 44,
            background: 'transparent',
            fontSize: '18px',
            lineHeight: '26px',
            fontWeight: 600,
          }}
          isLine={true}
        />
      </CustomTabs>

      <div style={{ paddingTop: 16 }}>
        <Outlet />
      </div>
    </div>
  );
};
